module.exports = __webpack_public_path__ + "img/older.80d1b426.webp";